import mapSliceToComponent from '~/imports/universal_page'
import { STORYBLOK_TYPES } from '~/lib/storyblok-types'

import SliceManager from '~/components/Abstracts/SliceManager'
import { PageViewAnalytics } from '~/components/PageViewAnalytics'
import TwoColumnsLayoutLine from '~/components/Slices/TwoColumnsLayoutLine'

import getBlogArticlePageStaticPropsFunction from '~/data/blog-article-page-data'
import { BlogArticlePageData } from '~/data/blog-article-page-data/serializer'
import { getStaticPathsFunction } from '~/data/page-data'

import css from '../styles.module.scss'

function BlogArticlePage({ slices, hero, ...props }: BlogArticlePageData) {
  return (
    <>
      <section className={css.BlogArticlePage}>
        {hero && <TwoColumnsLayoutLine {...hero} isHero />}
        <SliceManager
          mapSliceTypeToComponent={mapSliceToComponent}
          slicesData={slices}
        />
      </section>
      <PageViewAnalytics template="blog" />
    </>
  )
}

export default BlogArticlePage

export const getStaticProps = getBlogArticlePageStaticPropsFunction()
export const getStaticPaths = getStaticPathsFunction({
  type: STORYBLOK_TYPES.BLOG_ARTICLE_PAGE,
})
